import React from 'react';
import { addHours, format } from 'date-fns';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FaCheck, FaPlusCircle, FaTimes } from 'react-icons/fa';
import { formatCurrency } from '../../../../../../../utils/formatCurrency.js';

/**
 * @typedef {object} RecebivelConfirmDialogProps
 * @property {boolean} visible
 * @property {'add'|'upd'} mode
 * @property {Record<string, any>} recebivelTipoData
 * @property {boolean} isLoading
 * @property {() => void} onAccept
 * @property {() => void} onReject
 */

/**
 * Dialog de confirmacao para cadastro/atualizacao de recebivel.
 *
 * @param {RecebivelConfirmDialogProps} props
 * @returns {JSX.Element}
 */
export default function RecebivelConfirmDialog(props) {
    const { visible, mode, recebivelTipoData, isLoading, onAccept, onReject } = props;

    const footer = (
        <div className="w-full flex flex-row justify-between">
            <Button
                severity='success'
                style={{
                    minHeigth: '3vw',
                    minWidth: '15vw',
                }}
                label="Sim"
                icon={<FaCheck />}
                onClick={onAccept}
                loading={isLoading}
            />
            <Button
                severity='danger'
                style={{
                    minHeigth: '3vw',
                    minWidth: '15vw',
                }}
                label="Não"
                icon={<FaTimes />}
                onClick={onReject}
                loading={isLoading}
            />

        </div>
    );

    return (
        <Dialog
            header={
                mode === 'add'
                    ? 'Deseja cadastrar esta cobrança?'
                    : 'Deseja atualizar esta cobrança?'
            }
            onHide={onReject}
            visible={visible}
            style={{
                minHeigth: '30vw',
                minWidth: '50vw',
            }}
            footer={footer}
        >
            <div className="w-full flex p-3 md:justify-between md:text-left text-center">
                <div className="w-full md:w-7/12 mt-4">
                    {recebivelTipoData.valor && (
                        <p className='text-xl my-1'><b>Valor: </b>{formatCurrency(recebivelTipoData.valor)}</p>
                    )}
                    {recebivelTipoData.desconto && (
                        <p className='text-xl my-1'><b>Desconto ({recebivelTipoData.desconto_tipo}): </b>{recebivelTipoData.desconto}</p>
                    )}
                    {recebivelTipoData.data_inicio && (
                        <p className='text-xl my-1'><b>Data Início da Cobrança: </b>{format(addHours(new Date(recebivelTipoData.data_inicio), 3), 'dd/MM/yyyy')}</p>
                    )}
                    {recebivelTipoData.data_fim && (
                        <p className='text-xl my-1'>
                            <b>Data Final da Cobrança: </b>
                            {format(addHours(new Date(recebivelTipoData.data_fim), 3), 'dd/MM/yyyy')}
                        </p>
                    )}
                    {recebivelTipoData.vencimento && (
                        <p className='text-xl my-1'><b>Vencimento: </b>{recebivelTipoData.vencimento}º dia do mês</p>
                    )}
                    {recebivelTipoData.frequencia && (
                        <p className='text-xl my-1'><b>Frequência: </b>{recebivelTipoData.frequencia}</p>
                    )}
                </div>
                <div className="w-full md:w-1/3">
                    <FaPlusCircle
                        className="pi pi-plus-circle p-mr-3 ml-2 mt-4"
                        style={{ fontSize: '9rem' }}
                    />
                </div>
            </div>
        </Dialog>
    );
}
